/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import { IWebtopSearchConfig } from './Model';
import bind from 'apmui/decorators/bind';

interface ISearchViewConfig {
    search: IWebtopSearchConfig;
    onChange: (value: string) => void;
}
interface ISearchViewState {
    value: string;
}

class SearchView extends React.Component<ISearchViewConfig, ISearchViewState> {
    state: ISearchViewState = { value: '' };

    @bind
    onChange(evt: Event | React.SyntheticEvent<HTMLInputElement>) {
        const value = (evt.target as HTMLInputElement).value;
        this.setState({ value });
        this.props.onChange(value.trim());
    }

    @bind
    onReset() {
        this.setState({ value: '' });
        this.props.onChange('');
    }

    render() {
        const search = this.props.search;
        return (
            <div className="apmui-input-text" id="webtop-search">
                <img src={search.onImage} alt="" className="apmui-input--icon" />
                <input
                    onInput={this.onChange}
                    placeholder={search.title}
                    title={search.title}
                    aria-label={search.title}
                    type="search"
                    value={this.state.value}
                />
            </div>
        );
    }
}

export default SearchView;
